import React from "react";
import QuickLinksTile from "../../common/QuickLinksTile";
import Tile from "../../common/Tile";
import StaffListComponent from "../StaffList/StaffListComponent";
import { Constants } from "../../../constants/constants";
import { DashboardWebComponentProps } from "./DashboardWebComponent";
import LoaderPopupModel from "../../common/LoaderPopup";
import { resetUserRegistrationNewpayload } from "../../../store/slices/userOnboardSlice";
import { useDispatch  } from "react-redux";
import { AppDispatch } from "../../../store/store";

const DashboardMobileComponent: React.FC<DashboardWebComponentProps> = ({
  staffCount,
  handleTileClick,
  TitleMap,
  quickLinksData,
  navigate,
  isLoading,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  return (
    <div className="h-screen">
      <div className="bg-bgColor  pb-10">
        {isLoading && <LoaderPopupModel isOpen={isLoading} />}
        <div className="consentSubmitButton ml-4 pt-3  text-blackColor font-poppins">
          {Constants.overview}
        </div>
        <div className="flex  w-full justify-start px-4 gap-2">
          {staffCount &&
            Object.entries(staffCount)
              .filter(([key]) => key !== "passiveStaff") //  filter out passiveStaff
              .map(([key, value]) => (
                <div
                  className="cursor-pointer w-1/4 "
                  onClick={() => {
                    handleTileClick(key);
                  }}
                >
                  <Tile
                    title={TitleMap[key]}
                    count={value}
                    textStyle={{
                      title: "MobileResponsivesTileText text-wrap",
                      count: "userCount",
                    }}
                  />
                </div>
              ))}
        </div>

        <div className="consentSubmitButton ml-4 mt-3  text-blackColor font-poppins">
          {Constants.quickLinks}
        </div>
        <div className="flex gap-2 w-full  justify-start px-4 ">
          {Object.entries(quickLinksData).map(([key, value]) => (
            <div
              data-testid="quick-link-tile-mobile"
              className="cursor-pointer w-1/2 "
              onClick={() => {
                  dispatch(resetUserRegistrationNewpayload());
                navigate(value.link);
              }}
            >
              <QuickLinksTile
                title={value.title}
                description={value.description}
              />
            </div>
          ))}
        </div>
        <div className="px-4 pt-4">
          <StaffListComponent />
        </div>
      </div>
    </div>
  );
};

export default DashboardMobileComponent;
